import React from 'react';
import Icon from './icon';

export default function Loading() {

    return (
        <div className="loading-block"><Icon icon="loading"/></div>
    );
}



// WEBPACK FOOTER //
// ./src/js/components/loading.jsx